// extracted by mini-css-extract-plugin
export default {"baseStyles":"EQoCK"};